<lh-shared-ui-page-content>
  @if (showSuccessUI && createdStorageLocation) {
    <div class="tw-space-y-8 tw-max-w-xl tw-mx-auto">
      <div class="tw-flex tw-items-center tw-justify-center tw-h-32">
        <h1 class="tw-text-success">Success</h1>
      </div>

      <p>Your storage location {{ createdStorageLocation.name }} has been created successfully.</p>

      <div class="tw-bg-sky-100 tw-rounded-xl tw-p-4 tw-mx-auto tw-flex tw-items-center tw-gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="tw-w-5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
          />
        </svg>

        <p class="tw-text-sm tw-text-gray-600 tw-my-0">Please use the admin area to complete the onboarding process.</p>
      </div>

      <div class="tw-mt-4 tw-text-sm tw-text-gray-600">
        <p><span class="tw-font-semibold">Name:</span> {{ createdStorageLocation.name }}</p>
        <p><span class="tw-font-semibold">Storage Location ID:</span> {{ createdStorageLocation._id }}</p>
      </div>

      <p>Would you like to create another one?</p>

      <div class="tw-flex tw-justify-center tw-mt-8">
        <lh-shared-ui-button
          [style]="'info'"
          [variant]="'filled'"
          [size]="'small'"
          (click)="onCreateAnother()"
          [nativeLookAndFeel]="false"
          [tailwind]="true"
        >
          Create Another
        </lh-shared-ui-button>
      </div>
    </div>
  } @else {
    <div class="tw-space-y-8 tw-max-w-xl tw-mx-auto">
      <div class="tw-grid tw-grid-cols-12">
        <lh-shared-ui-label class="tw-col-span-9" [ngClass]="{ 'tw-col-span-12': !dxAllowFillForm }">
          <h1>{{ 'CREATE_STORAGE_LOCATION' | lhTranslate }}</h1>
          <p>{{ 'SHOP_SEARCH_GOOGLE_DESCRIPTION' | lhTranslate }}</p>
        </lh-shared-ui-label>

        @if (dxAllowFillForm) {
          <lh-shared-ui-button
            class="tw-col-span-3 tw-ml-auto tw-mt-4 tw-justify-self-end"
            type="button"
            [block]="true"
            [style]="'info'"
            [variant]="'filled'"
            [size]="'small'"
            (click)="dxFillForm()"
            [nativeLookAndFeel]="false"
            [tailwind]="true"
          >
            Fill Form
          </lh-shared-ui-button>
        }
      </div>

      <div>
        <form [formGroup]="accountLocationForm">
          <div [formGroupName]="'location'">
            <lh-shared-ui-label><h2>Location</h2></lh-shared-ui-label>

            <div class="tw-mb-4 tw-relative">
              <lh-places-search
                #placesSearch
                (click)="startTyping()"
                class="tw-w-full"
                [placeholder]="'SHOP_SEARCH_GOOGLE' | lhTranslate"
                (valueChange)="onPlaceChanged($event)"
                [location]="selectedLocation"
                [businessesOnly]="true"
                [disabled]="isNotOnGoogleMaps"
                [formControlMode]="true"
                [class.places-disabled]="isNotOnGoogleMaps"
                [class.missing]="selectedLocation !== null && !isNotOnGoogleMaps"
                [class.complete]="selectedLocation !== null && !isNotOnGoogleMaps"
              >
              </lh-places-search>
              <button
                id="stopTyping"
                [hidden]="!isTyping"
                class="close tw-absolute -tw-translate-y-1/2 tw-top-1/2 tw-right-4 tw-bg-transparent hover:tw-bg-slate-200 tw-rounded-full tw-h-6 tw-w-6"
                (click)="stopTyping()"
              >
                <svg _ngcontent-c3="" viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
                  <path
                    _ngcontent-c3=""
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                  ></path>
                  <path _ngcontent-c3="" d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </button>
            </div>

            <div class="tw-rounded-lg tw-overflow-hidden">
              <lh-shared-ui-input
                formControlName="name"
                label="Name"
                ariaLabel="Location Name"
                placeholder="Central Hotel Berlin"
                (valueChange)="geocodeAdress()"
                [nativeLookAndFeel]="nativeLookAndFeel"
                [tailwind]="true"
              />

              <div [formGroupName]="'address'">
                <lh-shared-ui-input
                  formControlName="street"
                  label="Street"
                  ariaLabel="Street"
                  placeholder="Main Street 123"
                  (valueChange)="geocodeAdress()"
                  [nativeLookAndFeel]="nativeLookAndFeel"
                  [tailwind]="true"
                />

                <lh-shared-ui-input
                  formControlName="city"
                  label="City"
                  ariaLabel="City"
                  placeholder="Berlin"
                  (valueChange)="geocodeAdress()"
                  [nativeLookAndFeel]="nativeLookAndFeel"
                  [tailwind]="true"
                />

                <lh-shared-ui-input
                  formControlName="postal"
                  label="Postal Code"
                  ariaLabel="Postal Code"
                  placeholder="12110"
                  (valueChange)="geocodeAdress()"
                  [nativeLookAndFeel]="nativeLookAndFeel"
                  [tailwind]="true"
                />

                <lh-shared-ui-input
                  formControlName="country"
                  label="Country"
                  ariaLabel="Country"
                  placeholder="Germany"
                  (valueChange)="geocodeAdress()"
                  [nativeLookAndFeel]="nativeLookAndFeel"
                  [tailwind]="true"
                />
                <input type="hidden" formControlName="countryCode" />
              </div>
            </div>

            <lh-shared-ui-label><h2>Storage Space</h2></lh-shared-ui-label>

            <div class="tw-rounded-lg tw-overflow-hidden">
              <lh-shared-ui-input
                type="number"
                formControlName="capacity"
                label="Capacity"
                ariaLabel="Capacity"
                placeholder="1000"
                [nativeLookAndFeel]="nativeLookAndFeel"
                [tailwind]="true"
              />

              <lh-shared-ui-input
                formControlName="accessCode"
                label="Access Code"
                ariaLabel="Access Code"
                placeholder="123456"
                [nativeLookAndFeel]="nativeLookAndFeel"
                [tailwind]="true"
              />

              <lh-shared-ui-textarea
                formControlName="storageRoomAccessText"
                label="Additional access information (optional)"
                ariaLabel="Additional access information (optional)"
                placeholder=""
                [nativeLookAndFeel]="nativeLookAndFeel"
                [tailwind]="true"
                [maxlength]="150"
              />
            </div>

            <lh-shared-ui-label><h2>Business</h2></lh-shared-ui-label>

            <div class="tw-rounded-lg tw-overflow-hidden">
              <lh-shared-ui-input
                formControlName="vat"
                label="VAT Number"
                ariaLabel="VAT Number"
                placeholder="DK12345678"
                [nativeLookAndFeel]="nativeLookAndFeel"
                [tailwind]="true"
              />
              <lh-shared-ui-checkbox
                [checked]="hasNoVatNumber"
                (change)="hasNoVatNumber = $event"
                label="I don't have a VAT number"
                ariaLabel="I don't have a VAT number"
                [nativeLookAndFeel]="nativeLookAndFeel"
                [tailwind]="true"
              />
            </div>
          </div>

          <lh-shared-ui-label><h2>Account Owner</h2></lh-shared-ui-label>

          <!-- Use [formGroupName] to access nested form groups -->
          <div [formGroupName]="'account'" class="tw-rounded-lg tw-overflow-hidden tw-bg-gray-even-lighter">
            <lh-shared-ui-input
              type="email"
              formControlName="email"
              label="E-mail"
              ariaLabel="E-mail"
              placeholder="jane.doe@example.com"
              [nativeLookAndFeel]="nativeLookAndFeel"
              [tailwind]="true"
            />
            <!-- @if (
                accountLocationForm.get('account.email')?.invalid && accountLocationForm.get('account.email')?.touched
              ) {
                <ion-item>
                  <ion-text color="danger">Please enter a valid email.</ion-text>
                </ion-item>
              } -->

            <lh-shared-ui-input
              type="tel"
              formControlName="phoneNumber"
              label="Phone Number"
              ariaLabel="Phone Number"
              placeholder="123 456 789"
              [nativeLookAndFeel]="nativeLookAndFeel"
              [tailwind]="true"
            />

            <div
              *ngIf="
                accountLocationForm.get('account.phoneNumber').dirty &&
                !accountLocationForm.get('account.phoneNumber').valid
              "
              class="alert alert-danger"
            >
              {{ 'INVALID_PHONE_NUMBER_COUNTRY' | translate }}
            </div>

            <lh-shared-ui-input
              formControlName="name"
              label="Name"
              ariaLabel="Name"
              placeholder="Jane Doe"
              [nativeLookAndFeel]="nativeLookAndFeel"
              [tailwind]="true"
            />
          </div>

          <div class="tw-my-2">
            <lh-shared-ui-spinner [visible]="isLoading()"></lh-shared-ui-spinner>
          </div>

          <div class="tw-mt-4 tw-text-danger">
            <span>{{ error() }}</span>
          </div>

          <div class="tw-mt-6">
            <lh-shared-ui-button
              [block]="true"
              [style]="'warning'"
              [disabled]="accountLocationForm.invalid || isLoading()"
              [nativeLookAndFeel]="nativeLookAndFeel"
              [tailwind]="true"
              (click)="onSubmit()"
            >
              {{ 'CREATE_STORAGE_LOCATION' | lhTranslate }}
            </lh-shared-ui-button>
          </div>
        </form>
      </div>
    </div>
  }
</lh-shared-ui-page-content>
